import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { axiosInstance } from 'src/api/axios';
import APIEndpoints from 'src/Member/api/APIEndpoints';
import CustomClientError from 'src/Member/errorhandling/CustomClientError';
import './TalonIntegration.scss';

function TalonIntegration() {
  const [jwtToken, setJwtToken] = useState(null);
  const [tokenError, setTokenError] = useState(false);
  const getTalonAuthToken = async () => {
    try {
      const tokenResponse = await axiosInstance.post(
        APIEndpoints.getTalonAuthToken(),
      );
      const jwt = tokenResponse?.data?.access_token;
      setJwtToken(jwt);
      return jwt;
    } catch (error) {
      console.log('talon-auth-error', error);
      setTokenError(true);
    }
  };

  useEffect(() => {
    const init = async () => {
      await getTalonAuthToken();
    };

    init();
  }, []);
  const iframeUrl = jwtToken
    ? `https://auth.mymedicalshopper.com/oauth2/mphasis-hef/callback?token=${jwtToken}&showNavbar=true`
    : null;

  return (
    <Container>
      <div className="mms-iframe-container">
        {tokenError ? (
          <div className="claims-no-data text-center">
            <CustomClientError
              CustomClasses="p-0 m-0"
              ErrorHeading="No Data found!"
              ErrorMessage=""
            />
          </div>
        ) : (
          <iframe
            src={iframeUrl}
            title="Medical Shopper Widget"
            style={{
              width: '99%',
              border: 0,
              left: 0,
              minHeight: '500px',
            }}
            allow="clipboard-write"
          />
        )}
      </div>
    </Container>
  );
}

export default TalonIntegration;
